import React, { useState } from 'react';
import { toast } from 'react-toastify';
import styles from '../styles/NewsletterSignup.module.css';

const NewsletterSignup = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (loading) {
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('/api/newsletter/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await response.json();

            if (!response.ok || !data.ok) {
                throw new Error(data.error || 'No se pudo suscribir');
            }

            toast.success('Listo, cada viernes te llegan las 10 mejores gangas.');
            setEmail('');
        } catch (error) {
            toast.error('Revisa el correo e intentalo de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className={styles.newsletter} aria-label="Suscripcion al resumen semanal">
            <div className={styles.copy}>
                <p className={styles.kicker}>Cada viernes, sin spam</p>
                <h2>Las 10 mejores gangas de la semana en tu correo</h2>
                <p>
                    Solo ofertas que siguen activas, con el descuento mas fuerte. Nada de avisos diarios,
                    un unico correo semanal.
                </p>
                <div className={styles.benefits} aria-label="Ventajas del resumen semanal">
                    <span>Sin relleno</span>
                    <span>Precio revisado</span>
                    <span>Baja en un clic</span>
                </div>
            </div>
            <form className={styles.form} onSubmit={handleSubmit}>
                <label>
                    <span>Tu correo</span>
                    <input
                        type="email"
                        required
                        placeholder="tucorreo@ejemplo.com"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                    />
                </label>
                <button type="submit" disabled={loading}>
                    {loading ? 'Enviando...' : 'Suscribirme'}
                </button>
                <p>Promesa simple: solo oportunidades que merecen abrir el email.</p>
            </form>
        </section>
    );
};

export default NewsletterSignup;
